import api from '../api'

// Super-admin "All Hubs" list: paginated + server-side search, backed by the
// /superAdmin/organizations endpoint. Full hub rows are stored in appState
// (keyed by `organization:<apikey>`) so the existing OrganizationList delete
// flow removes them from the list automatically, and so useOrganizations /
// organizations.load won't re-fetch them (we mark them `:loaded`).

const KEYS = {
  apikeys: 'allOrganizations:apikeys',
  page: 'allOrganizations:page',
  loading: 'allOrganizations:loading',
  error: 'allOrganizations:loading:error',
  lastPage: 'allOrganizations:lastPage',
  searchQuery: 'allOrganizations:searchQuery',
}

export async function load() {
  const state = this.getState()
  if (state[KEYS.loading] || state[KEYS.lastPage]) return

  const searchQuery = state[KEYS.searchQuery] || undefined
  const nextPage = typeof state[KEYS.page] === 'number' ? state[KEYS.page] + 1 : 0

  this.setState({ [KEYS.loading]: true, [KEYS.error]: undefined })

  try {
    const { organizations, lastPage } = await api.getAllOrganizations({ page: nextPage, searchQuery })

    // store full hub rows + mark loaded so nothing re-fetches them per-apikey
    this.takeAction('organization.addOrganizationsToAppState', organizations)
    const loadedFlags = {}
    organizations.forEach(({ apikey }) => { loadedFlags[`organization:${apikey}:loaded`] = true })
    this.setState(loadedFlags)

    this.addToSet(KEYS.apikeys, organizations.map(o => o.apikey))
    this.setState({
      [KEYS.page]: nextPage,
      [KEYS.lastPage]: lastPage,
      [KEYS.loading]: undefined,
    })
  } catch (error) {
    this.setState({ [KEYS.loading]: undefined, [KEYS.error]: error })
  }
}

// Reset the list and (re)load the first page for a new search term.
export function setSearchQuery(searchQuery) {
  const next = searchQuery || undefined
  const current = this.getState()[KEYS.searchQuery] || undefined
  if (next === current) return

  this.setState({
    [KEYS.searchQuery]: next,
    [KEYS.apikeys]: undefined,
    [KEYS.page]: undefined,
    [KEYS.lastPage]: undefined,
    [KEYS.error]: undefined,
  })
  this.takeAction('allOrganizations.load')
}
